<template>
    <div ref="dealstofollow">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="ui-block">
                <div class="ui-block-content">
                    <router-link to="/" style="color:#00AEEF" class="title">Back</router-link>
                </div>
            </div>
        </div>
        <div v-for="(deal,index) in allDeals" :key="index" class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="ui-block">
                <div class="birthday-item inline-items">
                    <div class="author-thumb">
                        <img width="40" height="38" :src="getAvatarLocal(deal.logo,deal.username)" alt="author">
                    </div>
                    <button :id=" 'followBBtn_' + index " @click=" deal.is_following === true ? unFollowDeals(deal.id,index) : followDeals(deal.id,index)" class="btn btn-sm bg-mdd btn-rounded">{{ deal.is_following === true ? 'Unfollow' : 'Follow' }}</button>
                    <div class="birthday-author-name">
                        <a href="#" class="h6 author-name">{{ deal.business_name === null || deal.business_name === '' ? deal.username : deal.business_name }} </a>
                        <div class="birthday-date">@{{deal.username}}</div>
                        <p style="width: 100%;">
                            {{ deal.business_desc }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import avta from "@/functions/getAvatar";
    import ls from "../../localstorage";

    export default {
        name: "DealsToFollow.vue",
        data() {
            return {
                allDeals: {},
                signedIn: false,
            }
        },
        methods: {
            showLoading() {
                let loader = this.$loader(this, this.$refs.dealstofollow, {
                    loaderType: "spinner"
                });
                return loader;
            },
            getBusinesses() {
                let userData = ls.getStorage("fansData");
                let loader = this.showLoading();
                this.axios
                    .get(`businesses/alias/${userData[0].id}/0`)
                    .then(response => {
                        loader.hide();
                        this.allDeals = response.data.data.businesses;
                        // console.log('deals to follow',response.data.data.businesses);
                    })
                    .catch(error => {
                        loader.hide();
                        // console.log(error.response);
                    });
            },
            followDeals(bid,index) {
                if(this.signedIn === true) {
                    $("#followBBtn_" + index).parent(".twitter-item").css('opacity','0.6');
                    $("#followBBtn_" + index).html('...');
                    this.axios.post('user/follow/' + bid)
                        .then(response => {
                            // console.log(response.data);
                            $("#followBBtn_" + index).parent(".twitter-item").css('opacity','1');
                            $("#followBBtn_" + index).html('Unfollow');
                            this.getBusinesses();
                            this.errorData = {
                                message: response.data.message,
                                isError: "success"
                            }
                        })
                        .catch(error => {
                            console.log(error.response);
                            $("#followBBtn_" + index).parent(".twitter-item").css('opacity','1');
                            $("#followBBtn_" + index).html('Follow');
                            this.errorData = {
                                message: error.response.data.message,
                                isError: true
                            }
                        })
                }else {
                    $('#loginBtn').click();
                }

            },
            unFollowDeals(bid,index) {
                if(this.signedIn === true) {
                    $("#followBBtn_" + index).parent(".twitter-item").css('opacity','0.6');
                    $("#followBBtn_" + index).html('...');
                    this.axios.post('user/unfollow/' + bid)
                        .then(response => {
                            // console.log(response.data);
                            $("#followBBtn_" + index).parent(".twitter-item").css('opacity','1');
                            $("#followBBtn_" + index).html('Follow');
                            this.getBusinesses();
                            this.errorData = {
                                message: response.data.message,
                                isError: "success"
                            }
                        })
                        .catch(error => {
                            console.log(error.response);
                            $("#followBBtn_" + index).parent(".twitter-item").css('opacity','1');
                            $("#followBBtn_" + index).html('Unfollow');
                            this.errorData = {
                                message: error.response.data.message,
                                isError: true
                            }
                        })
                }else {
                    $('#loginBtn').click();
                }

            },
            getAvatarLocal(avatar,username) {
                // let userData = localStorage.fansData;
                return avta({state:{ av: avatar, us: username }});
            },
            checkUserData(userData) {
                if (userData !== "" || userData !== "undefined") {
                    this.userData = JSON.parse(userData);
                    this.signedIn = true;
                }else {
                    this.$router.push('/');
                }
            },
        },
        mounted() {
            var userData = localStorage.fansData;
            if (userData) {
                this.checkUserData(userData);
            }
            this.getBusinesses();

            $("title").html("Businesses to follow / " + this.$store.state.projectName);
        }
    }
</script>

<style scoped>

</style>
